import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MenuProductType } from "../actions/types";

interface Props {
  menuProducts: MenuProductType[];
  setDropdownIsOpen: (isOpen: boolean) => void;
  closeMenu: () => void;
  style: any;
}

const MegaMenuProducts: React.FC<Props> = ({
  menuProducts,
  setDropdownIsOpen,
  closeMenu,
  style,
}) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string | number) => {
    navigate("/product-type/" + path);
    setDropdownIsOpen(false);
    closeMenu();
  };

  return (
    <div className="p-3 megamenu-container">
      <Row>
        {menuProducts.map((parent) => (
          <Col key={parent.id} lg={3} md={4} sm={6} xs={12} className="mb-4">
            <h6
              className="mb-3"
              style={{
                cursor: "pointer",
                fontWeight: 700,
                fontSize: "0.9rem",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                borderBottom: "1px solid #f0f0f0",
                paddingBottom: "8px",
                ...style,
              }}
              onClick={() => handleNavigate(parent.id)}
            >
              {parent.name}
            </h6>
            <ul className="list-unstyled">
              {parent.children?.map((child) => (
                <li key={child.id} className="mb-2">
                  <div
                    style={{
                      cursor: "pointer",
                      fontSize: "0.85rem",
                      textTransform: "capitalize",
                      color: "#212529",
                      ...style,
                    }}
                    className="mb-1"
                    onClick={() => handleNavigate(child.id)}
                  >
                    {child.name.toLowerCase()}
                  </div>
                  {child.children?.length > 0 && (
                    <ul className="list-unstyled ms-2 mt-1 border-start ps-2">
                      {child.children.map((subchild) => (
                        <li key={subchild.id} className="mb-1">
                          <div
                            style={{
                              cursor: "pointer",
                              fontSize: "0.85rem",
                              fontWeight: 400,
                              color: "#666",
                              textTransform: "capitalize",
                            }}
                            onClick={() => handleNavigate(subchild.id)}
                          >
                            {subchild.name.toLowerCase()}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </Col>
        ))}
        <Col lg={3} md={4} sm={6} xs={12} className="mb-4">
          <h6
            className="mb-3"
            style={{
              cursor: "pointer",
              fontWeight: 700,
              fontSize: "0.9rem",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: "8px",
              ...style,
            }}
            onClick={() => handleNavigate("weekly")}
          >
            Nuevos Ingresos
          </h6>
        </Col>
      </Row>
    </div>
  );
};

export default MegaMenuProducts;
